module.exports = __webpack_public_path__ + "img/wallet.3d89e028.svg";